// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type UpdateOwnerCorporateDataMutationVariables = Types.Exact<{
  upsertOwnerCorporateDataDTO: Types.UpsertOwnerCorporateDataDtoInput;
}>;


export type UpdateOwnerCorporateDataMutationResult = { __typename?: 'Mutation', updateOwnerCorporateData: boolean };

export const UpdateOwnerCorporateDataGql = gql`
    mutation UpdateOwnerCorporateData($upsertOwnerCorporateDataDTO: UpsertOwnerCorporateDataDTOInput!) {
  updateOwnerCorporateData(
    upsertOwnerCorporateDataDTO: $upsertOwnerCorporateDataDTO
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOwnerCorporateDataInjectable extends Apollo.Mutation<UpdateOwnerCorporateDataMutationResult, UpdateOwnerCorporateDataMutationVariables> {
    override document = UpdateOwnerCorporateDataGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */